import { Autocomplete, Button, FormControlLabel, Stack, Switch, TextField, Typography } from "@mui/material";
import React from "react";
import Modal, { CommonModalProps } from "..";
import { basketService } from "../../../Core/Api/services";
import { DbOrderBasketSaveInfos } from "../../../Core/Api/Types/db-order-basket-save-infos";
import useCustomSnackbar from "../../../Utils/Hooks/useCustomSnackbar";
import { useTranslation } from "react-i18next";

export type ModalLoadBasketElementProps = {
  onClose?: () => void;
  onLoadBasket: (id: number, clearBasket: boolean) => void;
};

export type ModalLoadBasketProps = CommonModalProps<ModalLoadBasketElementProps>;

const ModalLoadBasket = React.forwardRef<any, ModalLoadBasketProps>((_props, ref) => {
  const { t } = useTranslation();
  const { closeModal, onClose, onLoadBasket } = _props;
  const [selectedBasket, setSelectedBasket] = React.useState<DbOrderBasketSaveInfos | null>(null);
  const [clearBasket, setClearBasket] = React.useState<boolean>(false);
  const [loadedBaskets, setLoadedBaskets] = React.useState<DbOrderBasketSaveInfos[]>([]);
  const enqueueCustomSnackbar = useCustomSnackbar();

  const handleCancelClick: React.MouseEventHandler = () => {
    onClose && onClose();
    closeModal();
  };

  const onDeleteBasket = () => {
    basketService.DeleteSavedBasket(selectedBasket!.id).then(function (response) {
      if (response.success) {
        enqueueCustomSnackbar(t("alert:success.basketDeleted"), "primary");
        setLoadedBaskets(loadedBaskets.filter((x) => x.id !== selectedBasket?.id));
        setSelectedBasket(null);
      }
    });
  };

  React.useEffect(() => {
    basketService.ListSavedBaskets().then(function (response) {
      if (response.success) setLoadedBaskets(response.favorites || []);
    });
  }, []);

  return (
    <Modal
      title={t("modal:title.loadSavedBasket")}
      reference={ref}
      closeModal={closeModal}
      width={504}
      footer={
        <Stack direction="row" justifyContent="space-between">
          <Button onClick={handleCancelClick}>{t("common:cancel")}</Button>
          <Stack direction="row">
            <Button
              variant="contained"
              onClick={() => onDeleteBasket()}
              disabled={selectedBasket === null}
              sx={{ mr: 3 }}
            >
              {t("button:deleteBasket")}
            </Button>
            <Button
              variant="contained"
              onClick={() => onLoadBasket(selectedBasket!.id, true)}
              disabled={selectedBasket === null}
            >
              {t("button:loadBasket")}
            </Button>
          </Stack>
        </Stack>
      }
    >
      {loadedBaskets.length > 0 ? (
        <>
          <Autocomplete
            value={selectedBasket}
            onChange={(e, value) => setSelectedBasket(value)}
            options={loadedBaskets}
            sx={{ width: "100%" }}
            id={"typeFilter"}
            getOptionLabel={(option) => option.name ?? ""}
            renderInput={(params) => <TextField sx={{ mt: "-24px" }} {...params} />}
          />
          <FormControlLabel
            sx={{ mt: 3, ml: 1 }}
            control={<Switch size="small" checked={clearBasket} onChange={(e) => setClearBasket(e.target.checked)} />}
            label={t("field:label.clearActualBasket")}
          />
        </>
      ) : (
        <Typography variant="h3">{t("modal:body.noSavedBasket")}</Typography>
      )}
    </Modal>
  );
});

export default ModalLoadBasket;
